(function () {

    // Load YouTube Iframe API once
    let ytReady = false, ytLoading = false, ytWaiters = [];
    function loadYT(cb) {
        if (ytReady) return cb();
        ytWaiters.push(cb);
        if (ytLoading) return;
        ytLoading = true;

        const s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);

        window.onYouTubeIframeAPIReady = () => {
            ytReady = true;
            ytWaiters.forEach(f => f());
            ytWaiters = [];
        };
    }

    // Extract YouTube ID from URL or <iframe>
    function getYouTubeId(input) {
        if (!input) return null;

        // if oEmbed raw iframe string
        if (/<iframe/i.test(input)) {
            const m = input.match(/src=["']([^"']+)/i);
            if (m) input = m[1];
        }

        // handles youtu.be, watch?v=, embed/, shorts/
        const m = input.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
        return m ? m[1] : null;
    }

    function toBool(value, defaultValue = false) {
        if (value == null) return defaultValue;
        const v = String(value).toLowerCase().trim();
        if (v === 'true' || v === '1' || v === 'yes') return true;
        if (v === 'false' || v === '0' || v === 'no') return false;
        return defaultValue;
    }

    // Autoplay should be respectful (good for hero bg videos)
    function shouldAllowAutoplay() {
        const prefersReducedMotion =
            window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const saveData = navigator.connection?.saveData === true;

        return !(prefersReducedMotion || saveData);
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.VideoPlayer--hero').forEach(root => {
            const type = (root.dataset.type || '').toLowerCase();
            const src = root.dataset.src || '';

            const posterURL = root.dataset.poster || '';
            const iconURL = root.dataset.playIcon || '';

            // Data flags (HTML: data-autoplay="true", etc.)
            const autoplayRequested = toBool(root.dataset.autoplay, false);
            const autoplay = autoplayRequested && shouldAllowAutoplay();

            const controls = toBool(root.dataset.controls, true); // default true
            const muted = toBool(root.dataset.muted, false);
            const playsinline = toBool(root.dataset.playsinline, true);
            const loop = toBool(root.dataset.loop, false);

            // Ensure stage exists
            let stage = root.querySelector('.VideoPlayer__stage');
            if (!stage) {
                stage = document.createElement('div');
                stage.className = 'VideoPlayer__stage';
                root.prepend(stage);
            }

            // Ensure poster exists (keep in DOM; hide via CSS when is-started)
            let posterEl = stage.querySelector('.VideoPlayer__poster');
            if (!posterEl) {
                posterEl = document.createElement('img');
                posterEl.className = 'VideoPlayer__poster';
                posterEl.alt = '';
                stage.appendChild(posterEl);
            }
            if (posterURL) posterEl.src = posterURL;


            // Avoid binding multiple times if your code runs twice
            if (root.dataset.vpBound === '1') return;
            root.dataset.vpBound = '1';

            // Remove previous backend without touching poster
            function clearBackend() {
                stage.querySelectorAll('video, iframe, .VideoPlayer__holder').forEach(el => el.remove());
            }



            // Local file backend
            function bootLocal() {
                clearBackend();

                const v = document.createElement('video');
                v.src = src;
                v.playsInline = true;
                v.controls = controls;          // if you want no native controls, pass data-controls="false"
                v.preload = 'metadata';
                if (muted) v.muted = true;
                if (loop) v.loop = true;

                stage.appendChild(v);



                v.addEventListener('play', () => root.classList.add('is-playing'));
                v.addEventListener('pause', () => root.classList.remove('is-playing'));
                v.addEventListener('ended', () => root.classList.remove('is-playing'));

                if (autoplay) {
                    if (!root.classList.contains('is-started')) root.classList.add('is-started');
                    v.play().catch(() => { /* autoplay might be blocked if not muted */ });
                }
            }

            // YouTube backend
            function bootYouTube() {
                const id = getYouTubeId(src);
                if (!id) {
                    console.warn('[VideoPlayer] Invalid YouTube source:', src);
                    return;
                }

                loadYT(() => {
                    clearBackend();

                    const holder = document.createElement('div');
                    holder.className = 'VideoPlayer__holder';
                    holder.style.cssText = 'position:absolute;inset:0;';
                    stage.appendChild(holder);

                    let player;

                    const playerVars = {
                        controls: controls ? 1 : 0,
                        rel: 0,
                        modestbranding: 1,
                        playsinline: playsinline ? 1 : 0,
                        enablejsapi: 1
                    };

                    // For looping a single video, YouTube requires playlist=<id>
                    if (autoplay) {
                        playerVars.autoplay = 1;
                        playerVars.loop = 1;
                        playerVars.playlist = id;
                    }

                    player = new YT.Player(holder, {
                        videoId: id,
                        playerVars,
                        events: {
                            onReady: () => {
                                // Autoplay only reliably works when muted
                                if (muted) player.mute();

                                if (autoplay) {
                                    root.classList.add('is-started');
                                    player.playVideo();
                                }
                            },
                            onStateChange: (e) => {
                                const P = YT.PlayerState;

                                if (e.data === P.PLAYING) {
                                    root.classList.add('is-started'); // hide poster
                                    root.classList.add('is-playing'); // hide overlay while playing (your CSS)
                                } else if (e.data === P.PAUSED) {
                                    root.classList.remove('is-playing');
                                } else if (e.data === P.ENDED) {
                                    root.classList.remove('is-playing');
                                }
                            }
                        }
                    });

                });
            }

            if (type === 'file') bootLocal();
            else if (type === 'youtube') bootYouTube();
        });
    });
})();